import { Chip, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { KeyboardEvent, useState } from "react";

import styles from "../../../assets/styles/componentStyles/utility/chipTextField.module.scss";

interface ChipTextFieldProps {
    value: string[];
    onChange: (value: string[]) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    preventDuplicates?: boolean;
}

const ChipTextField = (props: ChipTextFieldProps) => {

    const {
        value,
        onChange,
        placeholder = "Type and press Enter",
        disabled = false,
        className = "",
        preventDuplicates = true,
    } = props;

    const [inputValue, setInputValue] = useState("");

    // Add Chip
    const addChip = (rawValue: string) => {
        const trimmedValue = rawValue.trim();

        if (!trimmedValue) {
            return;
        }

        if (preventDuplicates && value.some((chip) => chip.toLowerCase() === trimmedValue.toLowerCase())) {
            setInputValue("");
            return;
        }

        onChange([...value, trimmedValue]);
        setInputValue("");
    };

    // Remove Chip
    const removeChip = (indexToRemove: number) => {
        onChange(value.filter((_, index) => index !== indexToRemove));
    };

    // Handle Key Down
    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            event.preventDefault();
            addChip(inputValue);
            return;
        }

        if (event.key === "Backspace" && inputValue === "" && value.length > 0) {
            onChange(value.slice(0, -1));
        }
    };

    return (
        <div
            className={`${disabled ? styles.chipTextFieldDisabled : ""} ${className}`.trim()}
        >
            <TextField
                fullWidth
                variant="outlined"
                size="small"
                disabled={disabled}
                placeholder={placeholder}
                value={inputValue}
                onChange={(event) => setInputValue(event.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={() => addChip(inputValue)}
                className={styles.chipTextFieldInput}
                autoComplete="off"
                InputProps={{
                    startAdornment: value.length > 0 ? (
                        <div className={styles.chipTextFieldChips}>
                            {value.map((chip, index) => (
                                <Chip
                                    key={`${chip}-${index}`}
                                    label={chip}
                                    size="small"
                                    deleteIcon={<CloseIcon />}
                                    onDelete={() => removeChip(index)}
                                    className={styles.chipTextFieldChip}
                                />
                            ))}
                        </div>
                    ) : undefined,
                }}
            />
        </div>
    );
};

export default ChipTextField;